---
nb:
  page_hits:
    admin:
      filters:
        all_time: Hele tiden
        custom: Egendefinert
        matching_referrer_page: Samsvarende henvisningsside
        user_logged_in: Bruker logget inn
        week_ago: 1 uke siden
      table:
        action: Handling
        controller: Kontroller
        hit_count: Treffantall
        percentage: Prosent
      tabs:
        page_hits: Sidevisninger
        users: Brukere
